export function SubtractSquareIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <g clip-path="url(#clip0_11040_3668)">
        <path
          d="M4.83887 8H11.1603"
          stroke={props.color || '#626266'}
          stroke-width="1.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.6871 1.15137H4.31208C2.56647 1.15137 1.15137 2.56647 1.15137 4.31208V11.6871C1.15137 13.4327 2.56647 14.8478 4.31208 14.8478H11.6871C13.4327 14.8478 14.8478 13.4327 14.8478 11.6871V4.31208C14.8478 2.56647 13.4327 1.15137 11.6871 1.15137Z"
          stroke={props.color || '#626266'}
          stroke-width="1.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_11040_3668">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SubtractSquareIcon;
